import SV from 'server-vars';

export const shouldShowVipSoldCopies = ({ item, user }) =>
    item?.isSold && (user?.isVip || SV.get('userType') === 'vip');
